import styles from './SubTabsPage.module.scss';
import { PropsWithChildren, ReactNode } from 'react';

interface SubTabsPageContentProps {
  headerSummary?: ReactNode;
  headerActions?: ReactNode;
  body?: ReactNode;
}

export const SubTabsPageContent = ({
  headerSummary,
  headerActions,
  body,
}: PropsWithChildren<SubTabsPageContentProps>) => {
  // All of the elements are wrapped in a React Fragment so that they are in the same DOM tree level as the SubTabsPage tabs.
  // This enables the use of CSS Grid to position the elements differently to their natural order.
  return (
    <>
      {/* The summary node is slotted to the left of the SubTabsPage tabs. */}
      <div className={styles.subTabsPage__summary}>{headerSummary}</div>

      {/* SubTabsPage tabs are positioned inbetween these two elements using CSS. */}

      {/* The summary node is slotted to the left of the SubTabsPage tabs. */}
      <div className={styles.subTabsPage__actions}>{headerActions}</div>

      <div className={styles.subTabsPage__body}>{body}</div>
    </>
  );
};

export default SubTabsPageContent;
